module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-02.31e5260b.png";